
import { IModel, IAttribute, IViolation } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { Office365LinkedService } from 'app/model/linkedservice/office365.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { office365UserScopes } from 'app/registries/consts/metadata-consts';
import { format, sanitizeAndFormatString, stringIsNullOrEmpty } from 'app/shared/utils/string.util';

export enum FilterRequireMode {
    none = 0,
    defaultColumn = 1,
    all = 2
}

@Metamodel.model({
    name: adfModelTypeMap.office365.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Office365_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Office365_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: Office365LinkedService.MODEL // Linked service redefined
        }
    }
})
export class Office365Dataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly PREDICATE: IAttribute;
    public static readonly ALLOWEDGROUPS: IAttribute;
    public static readonly USERSCOPEFILTERURI: IAttribute;
    public static readonly DATEFILTERCOLUMN: IAttribute;
    public static readonly STARTTIME: IAttribute;
    public static readonly ENDTIME: IAttribute;

    @Metamodel.attribute({
        association: 'PREDICATE',
        templatable: true
    })
    public predicate: string;

    @Metamodel.attribute({
        association: 'ALLOWEDGROUPS',
        templatable: true
    })
    public allowedGroups: string[];

    @Metamodel.attribute({
        association: 'USERSCOPEFILTERURI',
        templatable: true
    })
    public userScopeFilterUri: string;

    @Metamodel.attribute({
        association: 'DATEFILTERCOLUMN',
        constraint: {
            validator: Office365Dataset.validatedateFilterColumn
        },
        templatable: true
    })
    public dateFilterColumn: string;

    @Metamodel.attribute({
        association: 'STARTTIME',
        constraint: {
            validator: Office365Dataset.validatedateStartTime
        },
        templatable: true
    })
    public startTime: string;

    @Metamodel.attribute({
        association: 'ENDTIME',
        constraint: {
            validator: Office365Dataset.validatedateEndTime
        },
        templatable: true
    })
    public endTime: string;

    public filterRequireMode: FilterRequireMode = FilterRequireMode.none;

    public userScope: string = office365UserScopes.all;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }

    public static validatedateFilterColumn(dataset: Office365Dataset): IViolation[] | undefined {
        if (stringIsNullOrEmpty(dataset.predicate) && dataset.filterRequireMode === FilterRequireMode.all
            && stringIsNullOrEmpty(dataset.dateFilterColumn) && stringIsNullOrEmpty(Office365Dataset.DATEFILTERCOLUMN.templateValue(dataset))) {
            return [{
                context: dataset.dateFilterColumn,
                message: () => sanitizeAndFormatString(stringResources.Office365RequireDateFilterColumnMessageWithTable, dataset.tableName, __IS_FABRIC_DPE__ ? stringResources.SourceInSmall : dataset.name)
            }];
        }
        return undefined;
    }

    public static validatedateStartTime(dataset: Office365Dataset): IViolation[] | undefined {
        if (stringIsNullOrEmpty(dataset.predicate) && dataset.filterRequireMode > 0
            && stringIsNullOrEmpty(dataset.startTime) && stringIsNullOrEmpty(Office365Dataset.STARTTIME.templateValue(dataset))) {
            return [{
                context: dataset.startTime,
                message: () => sanitizeAndFormatString(stringResources.Office365RequireStartTimeMessageWithTable, dataset.tableName, __IS_FABRIC_DPE__ ? stringResources.SourceInSmall : dataset.name)
            }];
        }
        return undefined;
    }

    public static validatedateEndTime(dataset: Office365Dataset): IViolation[] | undefined {
        if (stringIsNullOrEmpty(dataset.predicate) && dataset.filterRequireMode > 0
            && stringIsNullOrEmpty(dataset.endTime) && stringIsNullOrEmpty(Office365Dataset.ENDTIME.templateValue(dataset))) {
            return [{
                context: dataset.endTime,
                message: () => sanitizeAndFormatString(stringResources.Office365RequireEndTimeMessageWithTable, dataset.tableName, __IS_FABRIC_DPE__ ? stringResources.SourceInSmall : dataset.name)
            }];
        }
        return undefined;
    }
}
